import { NgModule } from '@angular/core';
import { StickyTableColModule } from './sticky-table-col/sticky-table-col.module';

@NgModule({
    exports: [StickyTableColModule],
})
export class DirectivesModule {}
